<template>
  <div class="awsacct-validation">
    <v-container fluid>
      <v-card class="pa-3">
        <v-form>
          <v-layout>
            <v-flex md5>
              <p class="font-weight-bold mt-4">ATTESTATION: Will the AWS cloud environment be used for DXC internal workload only?</p>
            </v-flex>
            <v-flex md3>
              <v-layout>
                <v-flex>
                  <v-btn-toggle v-model="newAwsAcctInternalClient.workload.dxcInternalUsedOnly" @change="isDxcInternalUsedOnly">
                    <v-btn
                      :class="{ 'v-btn--active': newAwsAcctInternalClient.workload.dxcInternalUsedOnly === 'Y' }"
                      value="Y"
                      class="black--text btn--qa">Yes</v-btn>
                    <v-btn
                      :class="{ 'v-btn--active': newAwsAcctInternalClient.workload.dxcInternalUsedOnly === 'N' }"
                      value="N"
                      class="black--text btn--qa">No</v-btn>
                  </v-btn-toggle>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex md6>
              <ul class="mb-2">
                <li>See Internal account qualifications in the Galaxy download "Internal/External Definitions". Internal accounts are not applicable for "client business data" nor "client access to the AWS environment."</li>
                <li v-if="isNotNewTrainingAccountPage">Internal DXC opportunities automatically qualify for the AWS Private Pricing Agreement tier discount at 21% off AWS list.</li>
              </ul>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-if="isNotNewTrainingAccountPage">
            <v-flex>
              <label class="font-weight-medium">Account Customer Name: {{ newAwsAcctInternalClient.workload.oppFields.account.Customer_Name }}</label>
              <!-- <v-text-field 
                v-model="newAwsAcctInternalClient.workload.oppFields.account.Customer_Name" 
                solo
                :readonly="true"
              /> -->
            </v-flex>
          </v-layout>
          <v-layout row wrap v-if="isNotNewTrainingAccountPage">
            <v-flex>
              <label class="font-weight-medium">Workload Status: {{ newAwsAcctInternalClient.workload.fields.Workload_Status }}</label>
              <!-- <v-text-field 
                v-model="newAwsAcctInternalClient.workload.fields.Workload_Status" 
                solo
                :readonly="true"
              /> -->
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md6>
              <label class="font-weight-medium">Provide a Project / Workload Title <span class="required">*</span></label>
              <v-text-field 
                v-model="newAwsAcctInternalClient.workload.fields.Workload_Title" 
                :disabled="newAwsAcctInternalClient.projectId ? true : false"
                placeholder="Project / Workload Title"
                solo
                name="Workload_Title"
                v-validate="'required'"
                data-vv-name="Workload_Title" 
                data-vv-validate-on="blur"
                :error-messages="errors.collect('Workload_Title')"
                @change="setRegistrationId"
              />
            </v-flex>
          </v-layout>
          <v-layout
            row
            wrap>
            <v-flex
              xs12
              md12 >
              <span class="font-weight-medium">Contact Information <span class="required">*</span></span>
              <v-checkbox
                id=""
                v-model="newAwsAcctInternalClient.workload.sameAsLoggedInUser"
                :disabled="newAwsAcctInternalClient.projectId ? true : false"
                color="orange"
                @change="onSameAsLoggedInUserChecked">
                <template v-slot:label>
                  Check this box if same as logged in user
                </template>
              </v-checkbox>
              <v-layout
                row
                wrap>
                <v-flex md6>
                  <v-text-field
                    v-validate="{ required: true, regex: /^[\w\-\s]+$/ }"
                    :clearable="!newAwsAcctInternalClient.workload.sameAsLoggedInUser"
                    v-model.lazy="newAwsAcctInternalClient.workload.contact.Contact_First_Name"
                    :error-messages="errors.collect('Contact_First_Name')"
                    :readonly="newAwsAcctInternalClient.workload.sameAsLoggedInUser || (newAwsAcctInternalClient.projectId ? true : false)"
                    placeholder="First Name"
                    solo
                    data-vv-name="Contact_First_Name"
                    data-vv-validate-on="blur"
                    required
                  />
                </v-flex>
                <v-flex md6>
                  <v-text-field
                    v-validate="{ required: true, regex: /^[\w\-\s]+$/ }"
                    :clearable="!newAwsAcctInternalClient.workload.sameAsLoggedInUser"
                    v-model.lazy="newAwsAcctInternalClient.workload.contact.Contact_Last_Name"
                    :error-messages="errors.collect('Contact_Last_Name')"
                    :readonly="newAwsAcctInternalClient.workload.sameAsLoggedInUser || (newAwsAcctInternalClient.projectId ? true : false)"
                    class="last-name"
                    placeholder="Last Name"
                    solo
                    data-vv-name="Contact_Last_Name"
                    data-vv-validate-on="blur"
                    required
                  />
                </v-flex>

              </v-layout>
              <v-layout
                row
                wrap>
                <v-flex md6>
                  <v-text-field
                    v-validate="'required|email'"
                    :clearable="!newAwsAcctInternalClient.workload.sameAsLoggedInUser"
                    v-model.lazy="newAwsAcctInternalClient.workload.contact.Contact_Email"
                    :error-messages="errors.collect('Contact_Email')"
                    :readonly="newAwsAcctInternalClient.workload.sameAsLoggedInUser || (newAwsAcctInternalClient.projectId ? true : false)"
                    class="email"
                    placeholder="Contact email"
                    solo
                    data-vv-name="Contact_Email"
                    data-vv-validate-on="blur"
                    required
                    @change="onContactEmailChange"
                  />
                </v-flex>
                <v-flex md6>
                  <v-text-field
                    :clearable="!newAwsAcctInternalClient.workload.sameAsLoggedInUser"
                    v-model.lazy="newAwsAcctInternalClient.workload.contact.Contact_Phone"
                    :readonly="newAwsAcctInternalClient.workload.sameAsLoggedInUser || (newAwsAcctInternalClient.projectId ? true : false)"
                    class="phone"
                    placeholder="Contact phone"
                    solo
                  />
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card>
      <v-card class="pa-3">
        <v-layout row justify-center>
          <v-flex xs12 sm12 md12 xl12 class="margin-bottom-5 text-md-right">
            <v-btn class="" value="true" @click="goBack"> Go Back to Previous Page</v-btn>
            <v-btn @click="goToAwsValidation" color="warning" :disabled="!newAwsAcctInternalClient.workload.fields.Workload_Title || !newAwsAcctInternalClient.workload.contact.Contact_Email || (!newAwsAcctInternalClient.workload.dxcInternalUsedOnly || newAwsAcctInternalClient.workload.dxcInternalUsedOnly == 'N' )">Next</v-btn>
          </v-flex>
        </v-layout>

          
      </v-card>
    </v-container>
  </div>
</template>
<script>
import { mapState, mapMutations} from 'vuex'
export default {
  computed: {
    ...mapState('user/requestAws', ['newAwsAcctInternalClient', 'awsOppRegistration']),
  },
  data () {
    return {
      isNotNewTrainingAccountPage: this.$route.name !== 'Request New Training Account'
    }
  },
  mounted () {
   
  },
  beforeDestroy () {
    // this.$store.commit('user/requestAws/clearValidation')
  },
  props: ['type'],
  methods: {
    ...mapMutations({
      updateContact: 'user/requestAws/setWorkloadContact',
      clearContact: 'user/requestAws/clearWorkloadContact'
    }),
    isDxcInternalUsedOnly(){
      if(this.newAwsAcctInternalClient.workload.dxcInternalUsedOnly === 'N'){
        this.$store.commit('user/requestAws/clearOppregId')
        this.$store.commit(
        'showDialog',
        {
          show: true,
          type: 'confirmation',
          persistent: true,
          title: 'If your response is "NO" and this workload does not qualify as an internal account you must choose from the left column "Request New Account for Existing Client" or "Request New Account for New Client".',
          // yesLabel: 'Proceed to Opportunity Registration',
          // yesHandler: () => {
          //   vm.$router.push({ path: `/request-oppreg/external-oppreg` })
          //    this.$store.commit('showDialog', { show: false })
          // },
          noHandler: () => {
            this.$store.commit('showDialog', { show: false })
          },
          noLabel: 'Close'
        },
        { root: true }
      )
      }
    }, 

    goBack () {
      console.log('Go back!')
      this.$emit('previous')
    },

    onSameAsLoggedInUserChecked (flag) {
      if (flag) {
        // Issue: vee validate error bag items is not being cleared if inputs did not emit change event. Issue is specific for contact info fields if error already occurs then we fill in state without triggering event.
        // this.clearErrorBagMessages(['Contact_First_Name', 'Contact_Last_Name', 'Contact_Email'])
        let contactUser = this.$store.state.currentUser
        this.updateContact({
          Contact_Id: contactUser.contact_id,
          Contact_Last_Name: contactUser.family_name,
          Contact_First_Name: contactUser.given_name,
          Contact_Email: contactUser.email,
          Contact_Phone: contactUser.phone
        })
      } else {
        this.clearContact()
      }
    },
    onContactEmailChange () {
      this.newAwsAcctInternalClient.contact.Contact_Id = ''
    },
    goToAwsValidation(){
      this.$store.commit('user/requestAws/addAccountOwner', {payload: this.newAwsAcctInternalClient, type: 'owner'})

      if (this.newAwsAcctInternalClient.projectId) {
        this.$store.commit('user/requestAws/setInternalRegistrationStep','validation')
      } else {
        this.$store.dispatch('user/requestAws/submitInternalWorkload', {payload: this.newAwsAcctInternalClient.workload, route: this.$route.name})
      }
    },
    setRegistrationId(){
      this.$store.commit('user/requestAws/setRegistrationId')
    }
  }
}
</script>
<style lang="scss" scoped>
  .v-btn-toggle { 
    margin:10px 0;

    .v-btn{
      padding: 15px 25px;
      font-weight: bold;
    }
  }

  .v-select__slot {
    label {
      font-weight: 500
    }
  }
  .awsacct-validation {
    .acknowledged-section {
      padding: 20px;
      background: #ff9900;

      &.les {
        background: yellow;
      }

      a {
        color: #000;
        text-decoration: underline;
      }
    }

    .confirm-validation {
      label {
        color: #000 !important;
        font-weight: 500 !important;
      }
    }
  }
</style>
